// mutations
const PAPELERIA_PRODUCTS_ALL = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_FORM = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_SHOW = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CREATE = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
    //alert(papeleriaProducts.message)
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_UPDATE = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
    alert(papeleriaProducts.message)
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_DELETE = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
    alert(papeleriaProducts.message)
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_ADD = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
    alert(papeleriaProducts.message)
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_MINUS = (state, papeleriaProducts) => {
  if (papeleriaProducts.code === 1) {
    state.papeleriaProducts = papeleriaProducts.data
    state.status = 'success'
    alert(papeleriaProducts.message)
  } else {
    alert(papeleriaProducts.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_PRODUCTS_ALL,
  PAPELERIA_PRODUCTS_FORM,
  PAPELERIA_PRODUCTS_SHOW,
  PAPELERIA_PRODUCTS_CREATE,
  PAPELERIA_PRODUCTS_UPDATE,
  PAPELERIA_PRODUCTS_DELETE,
  PAPELERIA_PRODUCTS_ADD,
  PAPELERIA_PRODUCTS_MINUS
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/mutations.js